import { cpfUtils } from './cpf.js';

/**
 * @typedef {import('../types/extraAdds').ExtraAdds} ExtraAdds
 */

/**
 *
 * @param {ExtraAdds} extraAdds
 * @returns {{valid: boolean, fields: string[]}}
 */
const isExtraAddsValid = extraAdds => {
  let fields = [];
  if (!extraAdds) return { valid: true };

  const { cpf } = extraAdds;
  if (cpf && !cpf.value) fields.push('cpf');

  if (fields.length) return { valid: false, fields };

  return { valid: true };
};

export const extraAdds = {
  cpfUtils,
  isExtraAddsValid,
};
